/** 
 * api接口的统一出口
 */
import common from './common_api' // 全局api
// 其他模块的接口……

// 导出接口
export default {
  common,
}